import { Grid, Typography, Table, TableBody, TableCell, TableHead, TableRow } from '@mui/material';
import React, { useContext } from 'react';
import { SearchContext } from '../../contexts/SearchContext';
import {
    ISearchResult
} from '../../interfaces';
import './index.scss';


export const ResultDetails: React.SFC<ISearchResult> = ({
    materialGroup,
    ...props
}: ISearchResult) => {

    const searchContext = useContext(SearchContext);

    const showProperty = (propertyName: string) => {
        return searchContext.resultOptions
            .filter(x => x.propertyName === propertyName)[0]
            ?.visible;
    }

    return (
        <>
            <Grid item xs={12}>
                <Typography
                    variant="subtitle2"
                    color="lightgrey"
                >
                    <strong>
                        Additional Details
                    </strong>
                </Typography>
            </Grid>

            {/*   <Grid item xs={12}>
                <Table className="result-details-table" sx={{ m:0 }} >

                    <TableHead>
                        <TableRow>
                            {showProperty("partNumber") && <TableCell>Part Number</TableCell>}
                            {showProperty("catalogueNumber") && <TableCell>Catalogue Number</TableCell>}
                            {showProperty("site") && <TableCell>Site</TableCell>}
                            {showProperty("hasUsageRestrictions") && <TableCell>Restricted Use</TableCell>}
                            {showProperty("contractRef") && <TableCell>Contract Ref</TableCell>}
                        </TableRow>
                    </TableHead>
                    <TableBody>
                        <TableRow >
                            {showProperty("partNumber") && <TableCell>{materialGroup.partNumber ? materialGroup.partNumber : "-"}</TableCell>}
                            {showProperty("catalogueNumber") && <TableCell>{materialGroup.catalogueNumber ? materialGroup.catalogueNumber : "-"}</TableCell>}
                            {showProperty("site") && <TableCell>{materialGroup.site ? materialGroup.site : "-"}</TableCell>}
                            {showProperty("hasUsageRestrictions") && <TableCell>{materialGroup.restricted ? materialGroup.restricted : "-"}</TableCell>}
                            {showProperty("contractRef") && <TableCell>{materialGroup.contractReferenceNumber ? materialGroup.contractReferenceNumber : "-"}</TableCell>}
                        </TableRow>

                    </TableBody>

                </Table>
            </Grid>*/}


            <Grid item xs={3} >
                {showProperty("partNumber") &&

                    <Typography className="material-property-text">
                        <strong>Part Number</strong> {materialGroup.partNumber}
                    </Typography>
                }
                {showProperty("catalogueNumber") &&
                    <Typography className="material-property-text">
                        <strong>Catalogue Number</strong> {materialGroup.catalogueNumber}
                    </Typography>
                }
            </Grid>

            <Grid item xs={3}>
                {showProperty("site") &&
                    <Typography className="material-property-text">
                        <strong>Site</strong> {materialGroup.site}
                    </Typography>
                }
                {showProperty("hasUsageRestrictions") &&
                    <Typography className="material-property-text">
                        <strong>Restricted Use</strong> {materialGroup.restricted}
                    </Typography>
                }

            </Grid>

            <Grid item xs={3}>


                {showProperty("contractReference") &&
                    <Typography className="material-property-text">
                        <strong>Contract Ref</strong> {materialGroup.contractReferenceNumber}
                    </Typography>
                }

            </Grid>


        </>);
}